function setupDrawer() {
  let mobileHeader = document.getElementById('shopify-section-mobile-header'),
    mobileNav = document.querySelector('.js-mobile-header'),
    mobileSearch = document.getElementById('mobile-search');
  const headerHeight = mobileHeader.offsetHeight + 'px';
  document.documentElement.style.setProperty('--header-height', headerHeight);
  
  // Thêm function xử lý search
  window.showSearchBar = function() {
    if (mobileSearch) {
      mobileSearch.style.display = mobileSearch.style.display === 'none' ? 'block' : 'none';
      // Set z-index khi hiển thị search
      mobileSearch.style.zIndex = mobileSearch.style.display === 'block' ? '13' : '0';
    }
  }

  window.hideMobileHeaderSection = function() {
    if (mobileSearch) {
      mobileSearch.style.display = 'none';
      mobileSearch.style.zIndex = '0';
    }
  }

  function getHeight(element) {
    element = element.cloneNode(true);
    element.style.visibility = "hidden";
    document.body.appendChild(element);
    var height = element.offsetHeight + 0;
    document.body.removeChild(element);
    element.style.visibility = "visible";
    return height;
  }

  Events.on('slideout:open:mobile-navigation', function(slideout) {
    setTimeout(function(){
      if (mobileNav) mobileNav.style.zIndex = '14';
      // Ẩn search khi mở navigation
      hideMobileHeaderSection();
    }, 200);
  });

  Events.on('slideout:close:mobile-navigation', function(slideout) {
    setTimeout(function(){
      if (mobileSearch) mobileSearch.style.zIndex = '0';
      if (mobileNav) mobileNav.style.zIndex = '12';
    }, 200);
  });

  // Khởi tạo ẩn search bar khi load trang
  if (mobileSearch) {
    mobileSearch.style.display = 'none';
    mobileSearch.style.zIndex = '0';
  }
}

// Phần code còn lại giữ nguyên
document.querySelectorAll('[data-section-type="mobile-header"]').forEach(function(container){
  WAU.Slideout.init("mobile-navigation");
  setupDrawer();
  if ( document.querySelector('.mobile-nav__mobile-header .js-mini-cart-trigger') ) {
    document.querySelector('.mobile-nav__mobile-header .js-mini-cart-trigger').addEventListener("click", function() {
      WAU.Slideout._closeByName("mobile-navigation");
    });
  }
});

// ... rest of the code remains the same